import * as localizations from './Localizations'
export const appStrings = localizations

export * from './Components/LocalizedRouter'
export * from './Components/LocalizedSwitch'
export * from './Components/LanguageSwitcher'
